module.exports = __webpack_public_path__ + "static/array3-d9e9fe018002e9ba2ef3305f87069ffb.png";